module.exports = __webpack_public_path__ + "img/43_39.a4b7f1ee.png";